import { createAxiosInstance } from './http';

export const submitSite = async (data) => {
  const res = await createAxiosInstance().post('/submit', data);
  return res.data;
};

